module.exports = __webpack_public_path__ + "img/btn-invite-join.5b25d94d.png";